import type {Editor} from 'grapesjs';
import type {PrimaryConfigOptions} from '../index';
import type {CTAButtonType, CTAButtonsType} from '../styles.types';

export default (opt: PrimaryConfigOptions): void => {
  const {editor} = opt;
  const styleManager = editor.StyleManager;

  styleManager.addType(window.PMW.emails.styles.ID_CTA_BUTTON, {
    create(data: any): HTMLElement {
      const props = data.props as CTAButtonsType;
      let el: HTMLElement;

      if (typeof props.buttons !== 'undefined' && Array.isArray(props.buttons)) {
        el = document.createElement('div');
        el.className = 'flex-v-row button-group-container';

        props.buttons.forEach((buttonProp: CTAButtonType): void => {
          const btn = createCtaButton(buttonProp, editor);
          el.appendChild(btn);
        });
      } else {
        el = createCtaButton(props, editor);
      }

      return el;
    },
  });

  function createCtaButton(props: CTAButtonType, editor: Editor): HTMLButtonElement {
    const button = document.createElement('button');
    const icon = document.createElement('i');
    const text = document.createElement('span');

    if (typeof props.cb === 'undefined') {
      props.cb = function (): void {
        // Default empty callback
      };
    }

    props.component = props.component ?? editor.getSelected();
    text.innerHTML = props.text ?? '';
    text.className = `btn-text js-cta-text`;
    button.className = `${props.type} btn small ${props.btnClass ?? ''}`;
    
    if (props.iconClass) {
      icon.className = `btn-icon size-icon-24 ${props.iconClass}`;
      button.appendChild(icon);
    }

    button.appendChild(text);
    
    if (props.cb) {
      button.addEventListener('click', (event: Event): void => {
        if (props.cb && props.component) {
          props.cb(editor, props.component, button, event);
        }
      });
    }

    return button;
  }
};